import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-common-types";
import { findIconDefinition } from "@fortawesome/fontawesome-svg-core";

export default function Icon(props: {
  name: IconName;
  size?: string;
  className?: string;
  empty?: boolean;
  onClick?: () => void;
}) {
  const iconClass = classNames("icon", props.className, {
    [`is-${props.size}`]: props.size?.length,
  });

  //Only way i found to verify if icon exists (since availability doesn't match list in QBank)
  const iconDefinition = findIconDefinition({
    prefix: "fas",
    iconName: props.name,
  });

  return (
    <span className={iconClass} onClick={props.onClick}>
      {!props.empty && (
        <FontAwesomeIcon
          icon={["fas", iconDefinition ? props.name : "question-circle"]}
        />
      )}
    </span>
  );
}
